module.exports = __webpack_public_path__ + "img/completed-animation.d9af20b4.svg";